import { useEffect } from 'react';
import { X, ChevronLeft, ChevronRight } from 'lucide-react';

/**
 * A picture shown large over the page. Click outside it, press Escape or use
 * the close button to leave; with more than one picture (the post's slides)
 * the arrows, or the left and right keys, move between them. The page behind
 * does not scroll while it is open.
 */
const ImageLightbox = ({ images, index, onClose, onIndex }) => {
    const image = images[index];
    const many = images.length > 1;

    useEffect(() => {
        const onKey = (e) => {
            if (e.key === 'Escape') onClose();
            else if (many && e.key === 'ArrowLeft') onIndex((index - 1 + images.length) % images.length);
            else if (many && e.key === 'ArrowRight') onIndex((index + 1) % images.length);
        };
        window.addEventListener('keydown', onKey);
        const before = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        return () => {
            window.removeEventListener('keydown', onKey);
            document.body.style.overflow = before;
        };
    }, [index, images.length, many, onClose, onIndex]);

    if (!image) return null;

    const button = {
        position: 'absolute', display: 'flex', alignItems: 'center', justifyContent: 'center',
        width: 44, height: 44, borderRadius: 999, border: 'none', cursor: 'pointer',
        background: 'rgba(255,255,255,0.14)', color: '#ffffff',
    };

    return (
        <div
            role="dialog"
            aria-modal="true"
            aria-label="Image"
            onClick={onClose}
            style={{ position: 'fixed', inset: 0, zIndex: 1000, background: 'rgba(10, 22, 16, 0.92)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}
        >
            <img
                src={image.src}
                alt={image.alt || ''}
                onClick={(e) => e.stopPropagation()}
                style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain', borderRadius: 8 }}
            />
            <button type="button" aria-label="Close" autoFocus onClick={onClose} style={{ ...button, top: 16, right: 16 }}>
                <X size={24} />
            </button>
            {many && (
                <>
                    <button type="button" aria-label="Previous image" onClick={(e) => { e.stopPropagation(); onIndex((index - 1 + images.length) % images.length); }} style={{ ...button, left: 16, top: '50%', transform: 'translateY(-50%)' }}>
                        <ChevronLeft size={26} />
                    </button>
                    <button type="button" aria-label="Next image" onClick={(e) => { e.stopPropagation(); onIndex((index + 1) % images.length); }} style={{ ...button, right: 16, top: '50%', transform: 'translateY(-50%)' }}>
                        <ChevronRight size={26} />
                    </button>
                </>
            )}
        </div>
    );
};

export default ImageLightbox;
